/** After shop create, persist catalog rows the same way offer-item screens do. */
export async function uploadShopCreateCatalog({ kind, api, brandName, items }) {
  const { uploadCatalogItemResumable } = await import('./catalogResumableUpload');
  for (let i = 0; i < (items || []).length; i++) {
    const item = items[i];
    await uploadCatalogItemResumable({
      kind,
      api,
      fields: {
        brand_name: brandName || '',
        item_name: item.name,
        description: item.description || `${item.name}. Submitted as part of shop catalog.`,
        price: item.price,
        ...(item.category ? { category: item.category } : {}),
        ...(item.subcategory ? { subcategory: item.subcategory } : {}),
        ...(item.size ? { size: item.size } : {}),
        fragile: item.fragile ? 'true' : 'false',
        weight_estimate_band: item.weight_estimate_band || 'under_2kg',
        in_stock: String(item.in_stock || '1'),
      },
      media: (item.images || []).map((img) => (
        img && typeof img === 'object' && !(img instanceof File)
          ? {
              file: img.file || img,
              name: img.name || img.file?.name,
              ...(img.pendingKey ? { pendingKey: img.pendingKey } : {}),
            }
          : img
      )),
      storageKey: `flea.shop_catalog.${kind}.${i}.v1`,
    });
  }
}
